export default "__VITE_PUBLIC_ASSET__abfbc1e6__"